import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import styles from './Divider.module.scss';

export const Divider = (props) => {
  const {vertical, className} = props;

  return (
    <div className={clsx(styles.container, {[styles.vertical]: vertical}, className)}>

    </div>
  );
};

Divider.propTypes = {
  vertical: PropTypes.bool
}

Divider.defaultProps = {
  vertical: false
}

export default Divider;